var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import * as PrimitiveDialog from "@react-components/primitives/Dialog/Dialog";
import { LazyMotion, domAnimation, m, AnimatePresence } from "framer-motion";
import { Chevron } from "@react-components/primitives/Icons/Icons";
import "./styles.scss";
import { containerVariants, itemVariants, panelItemVariants, panelVariants, } from "@react-components/ui/Panel/animations";
import * as RadixDialog from "@radix-ui/react-dialog";
import { RecoilRoot, useRecoilValue, useSetRecoilState } from "recoil";
import { panelOpenAtom } from "@react-components/ui/Panel/atoms";
var Root = function (_a) {
    var children = _a.children;
    var open = useRecoilValue(panelOpenAtom);
    var ref = useRef(null);
    return (_jsxs(LazyMotion, { features: domAnimation, children: [_jsx(m.div, { initial: open ? "hidden" : "entry", animate: open ? "hidden" : "visible", exit: "hidden", variants: panelVariants, children: React.Children.map(children, function (child) {
                    return React.isValidElement(child) && (_jsx(m.div, { variants: panelItemVariants, children: React.cloneElement(child, {
                            container: ref,
                        }) }));
                }) }), _jsx("div", { ref: ref })] }));
};
var Panel = function (_a) {
    var children = _a.children;
    return (_jsx(RecoilRoot, { children: _jsx("div", { className: "panel", children: _jsx(Root, { children: children }) }) }));
};
var Item = function (_a) {
    var _b;
    var title = _a.title, container = _a.container, children = _a.children, startActive = _a.startActive, otherProps = __rest(_a, ["title", "container", "children", "startActive"]);
    var _c = __read(useState(startActive), 2), isActive = _c[0], setIsActive = _c[1];
    var setOpenLevel = useSetRecoilState(panelOpenAtom);
    useEffect(function () {
        if (isActive) {
            setOpenLevel(isActive);
        }
    }, []);
    return (_jsx(PrimitiveDialog.DialogRoot, __assign({ open: isActive, onOpenChange: function (value) {
            setIsActive(value);
            setOpenLevel && setOpenLevel(value);
        }, modal: false }, otherProps, { children: _jsxs("div", { className: "panel__item", children: [_jsx("div", { className: "panel__forward-wrap", children: _jsxs(PrimitiveDialog.DialogTrigger, { type: "button", title: title, className: "panel__forward", children: [_jsx("span", { className: "panel__forward-text", children: title }), _jsx("span", { className: "panel__chevron", children: _jsx(Chevron, { size: 17 }) })] }) }), _jsx(RadixDialog.Portal, { container: (_b = container === null || container === void 0 ? void 0 : container.current) !== null && _b !== void 0 ? _b : null, forceMount: true, children: _jsx(_Fragment, { children: _jsx(AnimatePresence, { children: isActive && (_jsx(m.div, { initial: "out", animate: "in", exit: "out", variants: containerVariants, className: "panel__content-wrap", children: _jsxs(PrimitiveDialog.DialogContent, { forceMount: true, onInteractOutside: function (e) {
                                        return e.preventDefault();
                                    }, children: [_jsx(m.div, { variants: itemVariants, children: _jsxs(PrimitiveDialog.DialogClose, { type: "button", className: "panel__back", children: [_jsx("span", { className: "panel__back-chevron", children: _jsx(Chevron, { size: 16 }) }), _jsx("span", { className: "panel__back-text", children: title })] }) }), React.Children.map(children, function (child) {
                                            return React.isValidElement(child) && (_jsx(m.div, { variants: itemVariants, children: child }));
                                        })] }) })) }) }) })] }) })));
};
export { Panel, Item };
